import { createContext } from "react";
import { shapeComponent, ShapeComponent } from "set-state-compare/src/shape-component";
import { HostsContext } from "./portal-host";
import memo from "set-state-compare/src/memo";
const PortalsContext = createContext();
export { PortalsContext };
export default memo(shapeComponent(class ConjointmentPortalProvider extends ShapeComponent {
    hosts = {};
    newHosts = {};
    portals = {};
    providerValue = { provider: this };
    registerHost(host) {
        const name = host.p.name;
        this.tt.hosts[name] = host;
        for (const key in this.tt.portals) {
            const portal = this.tt.portals[key];
            if (portal.p.host == name) {
                host.registerPortal(portal);
            }
        }
    }
    registerPortal(portal) {
        this.portals[portal.tt.id] = portal;
    }
    unregisterHost(host) {
        delete this.tt.hosts[host.p.name];
    }
    unregisterPortal(portal) {
        delete this.portals[portal.tt.id];
    }
    render() {
        return (React.createElement(PortalsContext.Provider, { value: this },
            React.createElement(HostsContext.Provider, { value: this.tt.newHosts }, this.props.children)));
    }
}));
//# sourceMappingURL=portal-provider.js.map